const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const OVERALL_MIN = 65;
export const OVERALL_MAX = 99;

const SCORE_BASE = 0.25;
const SCORE_RANGE = 0.6;
const RESULT_WEIGHT = 0.6;
const INFLUENCE_WEIGHT = 0.3;
const CLEAN_WEIGHT = 0.1;
const ASSIST_INFLUENCE_FACTOR = 0.5;
const EXPECTATION_BONUS = 8;
const SESSION_INFLUENCE_WEIGHT = 0.8;
const HISTORY_WEIGHT = 1 - SESSION_INFLUENCE_WEIGHT;

export const calcularDesempenhoEsperado = (overall) => {
  const seguro = Number.isFinite(overall) ? overall : OVERALL_MIN;
  const normalizado = (clamp(seguro, OVERALL_MIN, OVERALL_MAX) - OVERALL_MIN) / (OVERALL_MAX - OVERALL_MIN);
  return Number((SCORE_BASE + normalizado * SCORE_RANGE).toFixed(3));
};

const normalizarInfluencia = ({ gols = 0, assistencias = 0, pontosParaVitoria = 1 }) => {
  const meta = Math.max(1, pontosParaVitoria);
  const bruto = Math.max(0, gols + assistencias * ASSIST_INFLUENCE_FACTOR);
  return clamp(bruto / meta, 0, 1);
};

export const calcularPontuacaoPartida = ({
  gols = 0,
  assistencias = 0,
  resultado = "loss",
  cleanSheet = false,
  pontosParaVitoria = 1,
}) => {
  const influencia = normalizarInfluencia({ gols, assistencias, pontosParaVitoria });

  let resultadoScore = 0;
  if (resultado === "win") {
    resultadoScore = 1;
  } else if (resultado === "draw") {
    resultadoScore = 0.4;
  }

  const cleanSheetScore = cleanSheet ? 1 : 0;

  const total =
    RESULT_WEIGHT * resultadoScore +
    INFLUENCE_WEIGHT * influencia +
    CLEAN_WEIGHT * cleanSheetScore;

  return {
    pontuacao: Number(clamp(total, 0, 1).toFixed(3)),
    influencia: Number(influencia.toFixed(3)),
  };
};

export const ajustarOverallComDesempenho = ({
  overallAtual,
  desempenhoReal,
}) => {
  const atualSeguro = Number.isFinite(overallAtual)
    ? clamp(overallAtual, OVERALL_MIN, OVERALL_MAX)
    : OVERALL_MIN;
  const desempenhoEsperado = calcularDesempenhoEsperado(atualSeguro);
  const diferenca = desempenhoReal - desempenhoEsperado;
  const desempenhoSessao = clamp(desempenhoReal, 0, 1);
  const overallSessao = OVERALL_MIN + desempenhoSessao * (OVERALL_MAX - OVERALL_MIN);
  const bonusExpectativa = diferenca * EXPECTATION_BONUS;
  const alvoSessao = clamp(overallSessao + bonusExpectativa, OVERALL_MIN, OVERALL_MAX);
  const novoOverall = clamp(
    atualSeguro * HISTORY_WEIGHT + alvoSessao * SESSION_INFLUENCE_WEIGHT,
    OVERALL_MIN,
    OVERALL_MAX
  );

  return {
    desempenhoEsperado,
    novoOverall: Number(novoOverall.toFixed(2)),
    delta: Number((novoOverall - atualSeguro).toFixed(2)),
  };
};
